import { type RouteRecordRaw } from "vue-router"
import {
  useApplicationStore,
  useProviderStore,
} from "@versatile-credit-apply/sdk"
import {
  usePrimaryProvider,
  useApplyMode,
} from "@versatile-credit-apply/composition"

export const FortivaDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "fortiva-apply-approved",
    path: "approved",
    component: () => import("./components/FortivaApproved.vue"),
  },
  {
    name: "fortiva-apply-declined",
    path: "declined",
    component: () => import("./components/FortivaDeclined.vue"),
  },
  {
    name: "fortiva-apply-pending",
    path: "pending",
    component: () => import("./components/FortivaPending.vue"),
  },
  {
    name: "fortiva-apply-error",
    path: "error",
    component: () => import("./components/FortivaError.vue"),
    beforeEnter: () => {
      const primaryProvider = usePrimaryProvider()
      const application = useApplicationStore().application
      const applyMode = useApplyMode()

      if (
        primaryProvider.value?.providerId !== "fortiva" &&
        application?.hasAgreedToCascade &&
        applyMode.value != "full"
      ) {
        return { name: "generic-apply-nooffer" }
      }
      return true
    },
  },
  {
    name: "fortiva-apply-nooffer",
    path: "nooffer",
    beforeEnter: () => {
      const primaryProvider = usePrimaryProvider()
      const application = useApplicationStore().application

      if (
        primaryProvider.value?.providerId !== "fortiva" &&
        application?.hasAgreedToCascade
      ) {
        return { name: "generic-apply-nooffer" }
      }
      return true
    },
    component: () => import("./components/FortivaNoOffer.vue"),
  },
  {
    name: "fortiva-apply-preapproved",
    path: "preapproved",
    component: () => import("./components/FortivaPreApproved.vue"),
    meta: {
      step: "applicant",
    },
  },
]

export const FortivaApplyRoutes: RouteRecordRaw[] = [
  {
    name: "fortiva-apply-routes",
    path: "fortiva_standard",
    children: [
      {
        name: "fortiva-apply-start",
        path: "start/:mode",
        component: () => import("./pages/FortivaIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "fortiva-terms",
        path: "terms",
        redirect: (to) => {
          const store = useProviderStore()

          if (
            store.currentProviderConfig?.properties
              ?.confirmElectronicTermsDelivery === true
          ) {
            return to.path + "/e-deliver"
          } else {
            return to.path + "/review"
          }
        },
      },
      {
        name: "fortiva-edeliver-terms",
        path: "terms/e-deliver",
        component: () =>
          import("./pages/FortivaElectronicTermsDeliveryPage.vue"),
        meta: {
          step: "terms",
          next: "review",
        },
      },
      {
        name: "fortiva-terms-review",
        path: "terms/review",
        component: () => import("./pages/FortivaApplyTermsPage.vue"),
        meta: {
          step: "terms",
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "../accept-offer" : "../submit"
          },
        },
      },
      {
        name: "fortiva-apply-decisions",
        path: "decision",
        component: () => import("./pages/FortivaDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: [...FortivaDecisionRoutes],
      },
      {
        name: "fortiva-apply-prequalified",
        path: "decision/prequalified",
        component: () => import("./pages/FortivaPlanSelectionPage.vue"),
        meta: {
          next: "../application",
          step: (steps) =>
            steps.includes("applicant") ? "applicant" : "reviewOffer",
        },
      },
    ],
  },
]
